import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import FollowUpsFormSubmitModel from "../../models/follow-ups-form-submit";

export default class FollowUpsFormSubmitRepository extends BaseRepository {
  static modelClass = FollowUpsFormSubmitModel;
  modelName = "follow-ups-form-submit";

  async createRecord(actionItemId, formId, payload) {
    if (!actionItemId || !formId) {
      throw new Error("Missing caseId or formId in submit()");
    }

    return await super.createRecord(payload, {
      urlPath: `actionable_items/${actionItemId}/forms/${formId}`,
    });
  }

  async patch(actionItemId, payload) {
    if (!actionItemId) {
      throw new Error("Missing caseId or formId in submit()");
    }

    return await super.patch("", payload, {
      urlPath: `actionable_items/${actionItemId}`,
    });
  }
}
